/*
 * @Author: Teemo Ding
 * @Date: 2021-11-10 10:21:55
 * @LastEditTime: 2023-03-17 08:26:58
 * @LastEditors: Json Chen
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Order/AllOrders/OrderDetail/Refund/Components/RefundDetail/index.tsx
 */
import { EditIcon } from '@/src/components/EditableTable/EditableTable';
import { EOperationType } from '@/src/types/common/order';
import { CaretDownOutlined } from '@ant-design/icons';
import { useRequest } from 'ahooks';
import { Input } from 'antd';
import { cloneDeep, get, set, toNumber } from 'lodash';
import React, { Fragment, useEffect, useMemo, useState } from 'react';
import {
  Alert,
  Checkbox,
  Form,
  Image,
  Label,
  ModalFooter,
  NumberInput,
  Select,
  SizeFittingTable,
  TextArea,
} from 'src/components/Antd';
import { OriCheckbox } from 'src/components/Antd/Checkbox/Checkbox';
import { EnumMode } from 'src/components/Antd/NumberInput/NumberInput';
import { TableNumberInputWithSlash } from 'src/components/EditableTable/TableForm1';
import GlobalTooltip, {
  NoWrapContainer,
} from 'src/components/GlobalTooltip/GlobalTooltip';
import { confirmRefundRequest } from 'src/request/order/refund';
import { isNumber } from 'src/tools/helper';
import { accAdd, accMul, accSub } from 'src/tools/math';
import { EnumTablePosition } from 'src/types/common/common';
import ExclusiveCustom from '../../../../../Components/ExclusiveCustom';
import SkuItems from '../../../../../Components/SkuItems';
import { ParentQty } from '../../../ReadyToPick';
import { EExternalRef } from '../../../tools';
import { calculatePrice } from './tool';
// const OriCheckboxGroup = OriCheckbox.Group;
import { useI18n } from '@/src/hooks/useRouterChange';
import { i18nGet, replaceI18nVariables } from '@/src/tools/tools';
import { getAreaCode, getAreaCodeInfo, getAreaCodeUuid } from 'src/tools/tools';
import css from './css.module.less';

interface IProps {
  onModalCancel: () => void;
  orderUuid: string;
  disabled?: boolean;
  currencyCode: string;
  refundDetail: any;
  onUpdate?: any;
  areaCodes: any;
  orderBuyerEmail?: any;
  buyerAreaCodeInfo?;
  buyerMobile?;
  storeDecimalPosition?: number;
  decimalPosition?: number;
  firstSubmit?: boolean;
}
enum IPaymentWay {
  Stripe = 'Stripe',
  GiftCard = 'GiftCard',
  BankTransfer = 'BankTransfer',
  NewStoreCredit = 'NewStoreCredit',
  Qfpay = 'Qfpay',
  WechatPay = 'WechatPay',
}

const tableName = 'refundDetail';
const formName = 'refunddetails';
const widthDict = {
  item: { minWidth: 190 },
  sku: { minWidth: 110 },
  qty: {
    width: 97,
  },
  tax: { width: 96 },
  paid: { width: 90 },
};

const RenderInputWidthSelect = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const dateList = [
    {
      value: 'Month',
      label: getI18n('general.month(s)'),
    },
    { value: 'Year', label: getI18n('general.year(s)') },
  ];
  const { value, onChange, disabled } = props;
  const { period, unit } = value || {};
  const handleInputChange = (inputValue: any) => {
    const targetValue = inputValue.target.value;
    onChange({ ...value, period: targetValue });
  };
  const handleSelectChange = (selectValue) => {
    onChange({ ...value, unit: selectValue });
  };
  return (
    <Fragment>
      <div className={css.expirationDate}>
        <Input
          value={period}
          disabled={disabled}
          className={css.shortInput}
          onChange={handleInputChange}
          size='large'
        />
        <Select
          value={unit}
          disabled={disabled}
          onChange={handleSelectChange}
          className={css.shortSelect}
          options={dateList}
          suffixIcon={<CaretDownOutlined className={css.selectIcon} />}
          size='large'
        />
      </div>
      {getI18n(
        'allOrders.orderDetail.refund_components_returndetail_after_refund',
      )}
    </Fragment>
  );
};

const RenderSelectWidthInput = (props) => {
  const { value, onChange, disabled, areaCodes } = props;
  const areaOptions = (areaCodes || []).map((item) => ({
    label: `(+${item.areaCode}) ${item.name}`,
    value: item.uuid,
  }));
  const { mobile, areaCodeInfo } = value || {};

  const handleInputChange = (inputValue) => {
    const targetValue = inputValue.target.value;
    onChange({ ...value, mobile: targetValue });
  };
  const handleSelectChange = (selectValue) => {
    const areaCodeInfo = getAreaCodeInfo(areaCodes, selectValue);
    onChange({ ...value, areaCodeInfo });
  };
  return (
    <Fragment>
      <div className={css.expirationDate}>
        <Select
          value={getAreaCodeUuid(areaCodeInfo)}
          onChange={handleSelectChange}
          options={areaOptions}
          disabled={disabled}
          className={css.buyerSelect}
          suffixIcon={<CaretDownOutlined className={css.selectIcon} />}
          size='large'
        />
        <Input
          value={mobile}
          disabled={disabled}
          className={css.buyerInput}
          onChange={handleInputChange}
          size='large'
        />
      </div>
    </Fragment>
  );
};

const RefundDetail = ({
  onModalCancel,
  orderUuid,
  disabled,
  currencyCode,
  refundDetail,
  onUpdate,
  areaCodes,
  orderBuyerEmail,
  buyerAreaCodeInfo,
  buyerMobile,
  storeDecimalPosition,
  decimalPosition,
  firstSubmit = false,
}: IProps) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const refundStoreCreditUuid = React.useRef<null>(null);
  const [form] = Form.useForm();
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [productDetail, setProductDetail] = useState(refundDetail.items);

  const {
    // items: productDetail = [],
    shippingFee = 0,
    taxes = [],
    handleBy = '',
    transactions = [],
    remark,
    subTotal: dataSubTotal,
    totalRefund: dataTotalRefund,
    items: dataItem,
    uuid: returnUuid,
    refundShippingFee,
    newStoreCredit,
    restock = false,
  } = refundDetail || {};
  const expandedRows = (productDetail || []).map((i) => i.uuid);
  // const stripePay = transactions.filter((o) => o.type === IPaymentWay.Stripe);
  const giftCardPay = transactions.filter(
    (o) => o.type === IPaymentWay.GiftCard,
  );
  const otherPay = transactions.filter(
    (o) =>
      o.type !== IPaymentWay.GiftCard && o.type !== IPaymentWay.NewStoreCredit,
  );
  // const bankTransferPay = transactions.filter(
  //   (o) => o.type === IPaymentWay.BankTransfer,
  // );

  // const customisationCheckedItems = productDetail.filter(
  //   (o) => o.customisationChecked,
  // );
  const { run: runConfirmRequest } = useRequest(
    (data) => confirmRefundRequest(data),
    {
      manual: true,
      onSuccess(res) {
        onModalCancel();
        if (onUpdate) onUpdate(res);
      },
    },
  );

  useEffect(() => {
    const stripeItem = {};
    otherPay.forEach((item) => {
      stripeItem[item.type] = {};
    });
    // stripeItem[IPaymentWay.Stripe] = {};
    stripeItem[IPaymentWay.GiftCard] = {};
    const allPay = transactions.filter(
      (o) => o.type !== IPaymentWay.NewStoreCredit,
    );
    allPay.forEach((item) => {
      stripeItem[item.type][item.chargedTransactionUuid] = {
        refund: item.refund,
      };
    });
    const checkedItems = dataItem
      .filter((o) => o.checked)
      .map((item) => item.uuid);
    setSelectedRowKeys(checkedItems);
    let refundItems = dataItem;

    if (disabled) {
      refundItems = dataItem.filter(
        (o) => o.checked || (!o.checked && o.customisationChecked),
      );
    } else if (firstSubmit) {
      refundItems.forEach((item) => {
        item.refundAmount = item.amount;
      });
    }
    setProductDetail(refundItems);
    const {
      unit = '',
      expirationPeriod,
      buyerAreaCodeInfo,
      buyerMobile,
      uuid,
    } = refundDetail.storeCredit || {};
    refundStoreCreditUuid.current = uuid;
    const defaultStoreCredit = {
      ...refundDetail.storeCredit,
      expirationDate: { period: expirationPeriod || 3, unit: unit || 'Month' },
      buyerPhoneNo: { areaCodeInfo: buyerAreaCodeInfo, mobile: buyerMobile },
    };
    form.setFieldsValue({
      taxes: taxes,
      newStoreCredit,
      storeCredit: defaultStoreCredit,
      refundShippingFee,
      remark: remark,
      transactions: stripeItem,
      restock,
    });
  }, []);

  const productSubTotal = useMemo(() => {
    return productDetail.reduce((pre, now) => {
      // const customCheck = Object.keys(
      //   form.getFieldValue('customCheck') || {},
      // );
      const {
        paidPrice: nowPaidPrice = 0,
        refundAmount: nowRefundAmount = 0,
        uuid: nowUuid,
        customisationChecked: nowCustomisationChecked,
        customisationPrice: nowCustomisationPrice,
      } = now;
      const isNowSelected = selectedRowKeys.includes(nowUuid);

      const nowTotal = isNowSelected
        ? accMul(nowPaidPrice || 0, nowRefundAmount || 0)
        : 0;

      const nowTotalCus = nowCustomisationChecked
        ? accAdd(nowTotal, nowCustomisationPrice)
        : nowTotal;
      return accAdd(pre, nowTotalCus);
    }, 0);
  }, [selectedRowKeys, productDetail]);

  const subTotalValue = disabled
    ? (dataSubTotal || 0).toFixed(decimalPosition)
    : (productSubTotal || 0).toFixed(decimalPosition);

  const columns = (onChange, data) => [
    {
      title: getI18n(
        'allOrders.orderDetail.refund_components_returndetail_columns_itemtitle',
      ),
      key: 'productName',
      dataIndex: 'productName',
      default: true,
      //optional: false,
      //className: css.tableCol,
      childGenerate: (text, record) => {
        const { productName } = record;
        const thumbnailUrl = get(record, 'image.url');
        return (
          <div className={css.productNameContainer}>
            <Image
              style={{
                marginRight: 12,
              }}
              width={40}
              height={40}
              key={thumbnailUrl}
              src={thumbnailUrl}
              alt={thumbnailUrl}
            />

            <NoWrapContainer>
              <GlobalTooltip zIndex={99999} title={productName || '-'}>
                <div className={css.text}>{productName || '-'}</div>
              </GlobalTooltip>
            </NoWrapContainer>
          </div>
        );
      },
      ...widthDict['item'],
    },
    {
      title: getI18n(
        'allOrders.orderDetail.refund_components_returndetail_columns_skutitle',
      ),
      key: 'SKU',
      default: true,
      //optional: false,
      //className: css.tableCol,
      childGenerate: (text, record) => {
        const { sku } = record;
        return (
          <NoWrapContainer>
            <GlobalTooltip zIndex={99999} title={sku || '-'}>
              {sku}
            </GlobalTooltip>
          </NoWrapContainer>
        );
      },
      ...widthDict['sku'],
    },
    {
      titleGenerate: () =>
        disabled ? (
          <span>
            {getI18n(
              'allOrders.orderDetail.refund_components_returndetail_columns_qty_titlegenerate',
            )}
          </span>
        ) : (
          <span>
            <EditIcon />{' '}
            {getI18n(
              'allOrders.orderDetail.refund_components_returndetail_columns_qty_titlegenerate',
            )}
          </span>
        ),
      key: 'QTY',
      default: true,
      //optional: false,
      //  className: css.tableCol,
      position: EnumTablePosition.right,
      childGenerate: (text, record, index) => {
        const { amount, refundAmount, uuid, checked } = record;
        const isParent = record[EExternalRef.isParent];
        if (isParent) {
          return <ParentQty set={record} data={data} />;
        }
        return disabled ? (
          checked ? (
            refundAmount
          ) : (
            0
          )
        ) : (
          <TableNumberInputWithSlash
            itemProps={{
              min: 1,
              max: amount,
              onBlur: (e) => {
                onChange(e, index, uuid);
              },
              backPart: (
                <div className={css.suffixPart}>
                  /
                  <NoWrapContainer>
                    <GlobalTooltip zIndex={99999} title={amount}>
                      {amount || '-'}
                    </GlobalTooltip>
                  </NoWrapContainer>
                </div>
              ),
            }}
            value={refundAmount}
            label={
              refundAmount == amount ? amount : `${refundAmount || 0}/${amount}`
            }
          />
        );
      },
      ...widthDict['qty'],
    },
    {
      title: getI18n(
        'allOrders.orderDetail.refund_components_returndetail_columns_taxtitle',
      ),
      key: 'Tax',
      default: true,
      align: 'right',
      className: css.taxColum,
      // position: EnumTablePosition.right,
      childGenerate: (text, record) => {
        const { tax } = record;
        const data = isNumber(tax) ? tax : '-';
        return (
          <NoWrapContainer>
            <GlobalTooltip zIndex={99999} title={data}>
              {data || '-'}
            </GlobalTooltip>
          </NoWrapContainer>
        );
      },
      ...widthDict['tax'],
    },
    {
      titleGenerate: () => (
        <div>
          {getI18n(
            'allOrders.orderDetail.refund_components_returndetail_columns_paidprice_titlegenerate',
          )}
        </div>
      ),
      key: 'Paid',
      default: true,
      position: EnumTablePosition.right,
      childGenerate: (text, record) => {
        const { paidPrice } = record;
        const data = isNumber(paidPrice)
          ? paidPrice.toFixed(decimalPosition)
          : 0; //.toFixed(2);
        return (
          <NoWrapContainer className={css.paidPrice}>
            <GlobalTooltip zIndex={99999} title={data}>
              {data || '-'}
            </GlobalTooltip>
          </NoWrapContainer>
        );
      },
      ...widthDict['paid'],
    },
  ];

  const onSelectChange = (selectedRowKeys, selectedRows) => {
    const _readyToPickItems = cloneDeep(productDetail || []);
    _readyToPickItems.forEach((item) => {
      if (selectedRowKeys.includes(item.uuid) && item.customisation) {
        item.customisationChecked = true;
      }
    });

    setProductDetail(
      _readyToPickItems.map((item) => {
        const { uuid } = item;
        if (selectedRowKeys.includes(uuid)) {
          return { ...item, checked: true };
        }
        return { ...item, checked: false };
      }),
    );
    setSelectedRowKeys(selectedRowKeys);
  };
  useEffect(() => {
    if (!disabled) {
      const stripeItem = {};
      otherPay.forEach((item) => {
        stripeItem[item.type] = {};
      });
      const allPay = transactions.filter(
        (o) => o.type !== IPaymentWay.NewStoreCredit,
      );

      allPay.forEach((item) => {
        set(stripeItem, `${item.type}.${item.chargedTransactionUuid}`, {
          refund: Number(subTotalValue),
        });
        // stripeItem[item.type][item.chargedTransactionUuid] = {
        //   refund: Number(subTotalValue),
        // };
      });
      form.setFieldsValue({
        transactions: stripeItem,
      });
    }
  }, [subTotalValue]);

  const onFinish = () => {
    form.validateFields().then((values) => {
      const {
        transactions,
        remark,
        refundShippingFee,
        storeCredit,
        newStoreCredit,
        restock,
      } = values;
      const _productDetail = cloneDeep(productDetail || []);
      const otherPayClone = otherPay.concat(giftCardPay);
      const taxes = form.getFieldValue('taxes');
      const showShippingFee = shippingFee > 0 && refundShippingFee;
      const { adjustment, totalRefund } = calculatePrice({
        transactions,
        shippingFee,
        showShippingFee,
        taxes,
        productSubTotal,
        storeCreditBalance: get(storeCredit, 'balance', 0),
      });
      otherPayClone.forEach((item) => {
        item.refund = (
          (transactions[item.type] || {})[item.chargedTransactionUuid] || {}
        ).refund;
      });
      _productDetail.forEach((item) => {
        if (selectedRowKeys.includes(item.uuid)) {
          item.checked = true;
        }
      });

      if (newStoreCredit) {
        storeCredit.expirationPeriod = get(
          storeCredit,
          'expirationDate.period',
        );
        storeCredit.unit = get(storeCredit, 'expirationDate.unit');
        storeCredit.orderBuyerEmail = get(storeCredit, 'orderBuyerEmail');
        storeCredit.buyerAreaCodeInfo =
          getAreaCodeUuid(buyerAreaCodeInfo) && buyerMobile
            ? buyerAreaCodeInfo
            : get(storeCredit, 'buyerPhoneNo.areaCodeInfo');
        storeCredit.buyerMobile =
          getAreaCodeUuid(buyerAreaCodeInfo) && buyerMobile
            ? buyerMobile
            : get(storeCredit, 'buyerPhoneNo.mobile');
        storeCredit.uuid = refundStoreCreditUuid.current;
      }

      const params = {
        type: EOperationType.Refund,
        orderUuid,
        items: _productDetail,
        transactions: otherPayClone,
        remark,
        adjustment,
        totalRefund,
        subTotal: productSubTotal,
        refundShippingFee,
        uuid: returnUuid,
        shippingFee,
        taxes,
        restock,
        newStoreCredit,
        ...(newStoreCredit ? { storeCredit } : {}),
      };
      runConfirmRequest(params);
    });
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
    getCheckboxProps: (record) => {
      // const disabled = form.getFieldsValue();
      return {
        // disabled: true,
        name: record.name,
      };
    },
  };
  const onQuantityChange = (refundAmount, index, uuid) => {
    const _readyToPickItems = cloneDeep(productDetail || []);
    (_readyToPickItems[index] || {}).refundAmount = refundAmount;
    setProductDetail(_readyToPickItems);
  };

  const handleCustomChecked = (value, expandedIndex) => {
    const {
      target: { checked },
    } = value;
    const _readyToPickItems = cloneDeep(productDetail || []);
    (_readyToPickItems[expandedIndex] || {}).customisationChecked = checked;
    setProductDetail(_readyToPickItems);
  };
  return (
    <Fragment>
      <Form
        name={formName}
        onFinish={onFinish}
        form={form}
        className={css.refundDetail}>
        <div className={css.refundDetailContain}>
          <SizeFittingTable
            rowKey='uuid'
            pagination={false}
            dataSource={productDetail}
            className={css.detailTable}
            id={tableName}
            rowClassName={(record) =>
              !record.checked && record.customisationChecked && disabled
                ? css.disabled
                : css.show
            }
            columns={columns(onQuantityChange, productDetail)}
            {...(!disabled ? { rowSelection: rowSelection } : {})}
            expandable={{
              expandedRowClassName: (record) => {
                const isParent = get(record, EExternalRef.isParent);
                const isChild = get(record, EExternalRef.isChild);
                const isLast = get(record, EExternalRef.isLast);
                const shouldHideBottomLine = (isParent || isChild) && !isLast;
                return `${css.expandedRow} ${
                  shouldHideBottomLine ? css.hideBottomLine : ''
                }`;
              },
              expandedRowRender: (record, expandedIndex) => {
                const isChild = get(record, EExternalRef.isChild);
                const customisationItem =
                  get(record, 'customisation.items') || [];
                const skuItems = get(record, 'simpleProducts') || [];
                const optionValues = get(record, 'optionValues') || [];
                const customisationChecked = get(
                  record,
                  'customisationChecked',
                  false,
                );
                const exclusiveCustomData = (customisationItem || []).map(
                  (item) => ({
                    title: `${item.title} : ${(item.values || []).join(',')}`,
                  }),
                );

                const customisationPrice =
                  get(record, 'customisationItem.formattedPaidPrice') || '';
                const skuItemsOptions = skuItems.map((item) => [
                  item.productName,
                  item.sku,
                ]);
                if (isChild) {
                  return <React.Fragment />;
                }
                if (
                  !customisationItem.length &&
                  !skuItems.length &&
                  !optionValues.length
                ) {
                  return <React.Fragment />;
                }
                return (
                  <React.Fragment>
                    <div className={css.optionValues}>
                      {optionValues.map((item, index) => (
                        <span key={index}>
                          {item.label}:{item.value},
                        </span>
                      ))}
                    </div>
                    <div className={css.customizationLine}>
                      <div className={css.skuItems}>
                        <SkuItems data={skuItemsOptions} />
                      </div>

                      {!!customisationItem.length && disabled && (
                        <div className={css.disabledCustom}>
                          <ExclusiveCustom data={exclusiveCustomData} />
                          {customisationPrice}
                        </div>
                      )}
                      {!!customisationItem.length && !disabled && (
                        <div className={css.customisationChecked}>
                          <OriCheckbox
                            checked={customisationChecked}
                            onChange={(value) =>
                              handleCustomChecked(value, expandedIndex)
                            }
                            disabled={selectedRowKeys.includes(record.uuid)}
                            className={css.customisationItem}>
                            <ExclusiveCustom data={exclusiveCustomData} />
                          </OriCheckbox>
                          <span>{customisationPrice}</span>
                        </div>
                      )}
                    </div>
                  </React.Fragment>
                );
              },
              expandIconColumnIndex: -1,
              indentSize: 0,
              expandedRowKeys: expandedRows,
            }}
          />
          <div className={css.refundDetailContainCheckbox}>
            {shippingFee > 0 && (
              <Form.Item
                name='refundShippingFee'
                valuePropName='checked'
                noStyle>
                <OriCheckbox disabled={disabled}>
                  {getI18n(
                    'allOrders.orderDetail.refund_components_returndetail_return_refund_shipping_fee',
                  )}
                </OriCheckbox>
              </Form.Item>
            )}

            {(taxes || []).map((item, index) => (
              <Form.Item
                key={index}
                valuePropName='checked'
                name={['taxes', index, 'checked']}>
                <OriCheckbox disabled={disabled}>{item.name}</OriCheckbox>
              </Form.Item>
            ))}
          </div>
          <div className={css.refundDetailReason}>
            <Form.Item
              label={
                <Label
                  titleContainerClassName={css.label}
                  title={getI18n(
                    'allOrders.orderDetail.refund_components_returndetail_return_reason_for_refundtitle',
                  )}
                  textLength={500}
                  nameKey='remark'
                />
              }
              className={css.reason}
              name='remark'
              labelCol={{ span: 24 }}>
              <TextArea disabled={disabled} size='large' maxLength={500} />
            </Form.Item>
            <div className={css.handleBy}>
              <h3 className={css.textTitle}>
                {getI18n('allOrders.orderDetail.handleby')}
              </h3>
              <p>{handleBy}</p>
            </div>
          </div>
          <Form.Item
            className={css.restock}
            name='restock'
            valuePropName='checked'>
            <Checkbox disabled={disabled}>
              {getI18n(
                'allOrders.orderDetail.refund_components_returndetail_return_restock_checkbox',
              )}
            </Checkbox>
          </Form.Item>
        </div>
        <div className={css.refundDetailRight}>
          <Form.Item
            noStyle
            shouldUpdate={(prevValues, curValues) =>
              prevValues.transactions !== curValues.transactions ||
              prevValues.refundShippingFee !== curValues.refundShippingFee ||
              prevValues.taxes !== curValues.taxes ||
              prevValues.storeCredit !== curValues.storeCredit
            }>
            {({ getFieldValue }: any) => {
              const transactions = getFieldValue('transactions') || {};
              const showShippingFee =
                shippingFee > 0 && getFieldValue('refundShippingFee');
              const { adjustment, totalRefund } = calculatePrice({
                transactions,
                shippingFee,
                showShippingFee,
                taxes,
                productSubTotal,
                storeCreditBalance:
                  (getFieldValue('storeCredit') || {}).balance || 0,
              });
              return (
                <Fragment>
                  <h3>{getI18n('allOrders.orderDetail.refundSummary')}</h3>
                  <div className={css.refundDetailSummary}>
                    <p>
                      <span>
                        {getI18n(
                          'allOrders.orderDetail.orderinfo_return_subtotal',
                        )}
                      </span>{' '}
                      <span>${subTotalValue}</span>
                    </p>
                    {showShippingFee && (
                      <p>
                        <span>
                          {getI18n('allOrders.orderDetail.shippingFee')}
                        </span>
                        <span>
                          ${(shippingFee || 0).toFixed(decimalPosition)}
                        </span>
                      </p>
                    )}
                    {(getFieldValue('taxes') || []).map(
                      (item, index) =>
                        item.checked && (
                          <p key={index}>
                            <span>{item.name}</span>{' '}
                            <span>${item.taxValue || item.taxPrice}</span>
                          </p>
                        ),
                    )}

                    {adjustment > 0 && (
                      <p>
                        <span>
                          {getI18n('allOrders.orderDetail.adjustment')}
                        </span>
                        <span>
                          - ${(adjustment || 0).toFixed(decimalPosition)}
                        </span>
                      </p>
                    )}
                    <p>
                      <span>{getI18n('allOrders.orderDetail.total')}</span>{' '}
                      <span>
                        $
                        {disabled
                          ? (dataTotalRefund || 0).toFixed(decimalPosition)
                          : (totalRefund || 0).toFixed(decimalPosition)}
                      </span>
                    </p>
                  </div>
                  {adjustment > 0 && (
                    <Alert
                      type='warning'
                      className={css.alert}
                      message={
                        <div>
                          <p>
                            {getI18n(
                              'allOrders.orderDetail.adjustmentwarningtext',
                            )}
                          </p>
                          <p>
                            {getI18n('allOrders.orderDetail.difference')} :{' '}
                            <span className={css.bold}>- ${adjustment}</span>
                          </p>
                        </div>
                      }
                    />
                  )}
                </Fragment>
              );
            }}
          </Form.Item>

          <h3>
            {getI18n(
              'allOrders.orderDetail.refund_components_returndetail_return_refund_to',
            )}
          </h3>
          {(otherPay || []).map((item, index) => (
            <div key={index} className={css.refundDetailRefundTo}>
              <div>
                <div className={css.refundDetailRefundToTitle}>
                  {get(item, 'transactionInfo.paymentMethodName')} ({' '}
                  {get(item, 'transactionInfo.provider')})
                </div>
                {item.type == IPaymentWay.Stripe &&
                  get(
                    item,
                    'transactionInfo.paymentDetail.gatewayReferenceId',
                  ) && (
                    <div className={css.cardNo}>
                      {getI18n(
                        'allOrders.orderDetail.refund_components_returndetail_return_payment_method_id',
                      )}
                      {get(
                        item,
                        'transactionInfo.paymentDetail.gatewayReferenceId',
                      )}
                    </div>
                  )}
                {item.type == IPaymentWay.WechatPay &&
                  get(
                    item,
                    'transactionInfo.paymentDetail.gatewayReferenceId',
                  ) && (
                    <div className={css.cardNo}>
                      {getI18n(
                        'allOrders.orderDetail.refund_components_returndetail_return_payment_method_id',
                      )}
                      {get(
                        item,
                        'transactionInfo.paymentDetail.gatewayReferenceId',
                      )}
                    </div>
                  )}

                {item.type == IPaymentWay.Qfpay &&
                  get(
                    item,
                    'transactionInfo.paymentDetail.gatewayReferenceId',
                  ) && (
                    <div className={css.cardNo}>
                      SYSSN:
                      {get(
                        item,
                        'transactionInfo.paymentDetail.gatewayReferenceId',
                      )}
                    </div>
                  )}
                <Form.Item
                  name={[
                    'transactions',
                    item.type,
                    item.chargedTransactionUuid,
                    'refund',
                  ]}
                  rules={[
                    {
                      type: 'number',
                      max: item.available,
                      message: getI18n(
                        'allOrders.orderDetail.refund_components_returndetail_return_amount_formitem_rules_message',
                      ),
                    },
                  ]}>
                  <NumberInput
                    disabled={disabled}
                    size='large'
                    mode={EnumMode.money}
                    suffix={currencyCode}
                    decimalPosition={decimalPosition}
                  />
                </Form.Item>

                <span className={css.explain}>
                  {replaceI18nVariables(
                    getI18n(
                      'allOrders.orderDetail.refund_components_returndetail_return_explain',
                    ),
                    isNumber(decimalPosition) && isNumber(item.available)
                      ? item.available.toFixed(decimalPosition)
                      : item.available,
                  )}
                </span>
              </div>
            </div>
          ))}

          {(giftCardPay || []).length ? (
            <div className={css.refundDetailRefundTo}>
              {giftCardPay.map((item, index) => (
                <div
                  key={index}
                  className={index !== giftCardPay.length - 1 && css.stripePay}>
                  <div className={css.refundDetailRefundToTitle}>
                    {item.type} (SKU{item.giftCard.cardNo})
                  </div>
                  <div>{item.giftCard.redemptionCode}</div>
                  <div>
                    {getI18n(
                      'allOrders.orderDetail.refund_components_returndetail_return_giftcardpay_length_expiration',
                    )}
                    {item.giftCard.expireAt}
                  </div>

                  <div className={css.cardNo}>
                    {getI18n('allOrders.orderDetail.balance')}:
                    {item.giftCard.balance}
                  </div>
                  <Form.Item
                    name={[
                      'transactions',
                      IPaymentWay.GiftCard,
                      item.chargedTransactionUuid,
                      'refund',
                    ]}
                    rules={[
                      {
                        type: 'number',
                        max: item.available,
                        message: getI18n(
                          'allOrders.orderDetail.transactionsrefundwarningtext',
                        ),
                      },
                    ]}>
                    <NumberInput
                      disabled={disabled}
                      size='large'
                      mode={EnumMode.money}
                      suffix={currencyCode}
                      decimalPosition={decimalPosition}
                    />
                  </Form.Item>

                  <span className={css.explain}>
                    {replaceI18nVariables(
                      getI18n(
                        'allOrders.orderDetail.refund_components_returndetail_return_explain',
                      ),
                      item.available,
                    )}
                  </span>
                </div>
              ))}
            </div>
          ) : null}

          <div className={css.refundDetailRefundTo}>
            <Form.Item
              valuePropName='checked'
              className={css.newStoreCredit}
              name={'newStoreCredit'}
              labelCol={{ span: 24 }}>
              <Checkbox
                disabled={disabled}
                onChange={(checked: boolean) => {
                  if (!checked) {
                    const currentValue = form.getFieldsValue(true);
                    form.setFieldsValue({
                      ...currentValue,
                      storeCredit: {
                        ...currentValue.storeCredit,
                        balance: 0,
                      },
                    });
                  }
                }}>
                {getI18n(
                  'allOrders.orderDetail.refund_components_returndetail_return_refundDetailRefundTo_checkbox',
                )}
              </Checkbox>
            </Form.Item>
            <Form.Item
              noStyle
              shouldUpdate={(prevValues, curValues) => {
                return (
                  get(prevValues, 'newStoreCredit') !==
                    get(curValues, 'newStoreCredit') ||
                  otherPay.some(
                    (item) =>
                      get(prevValues, [
                        'transactions',
                        item.type,
                        item.chargedTransactionUuid,
                        'refund',
                      ]) !==
                      get(curValues, [
                        'transactions',
                        item.type,
                        item.chargedTransactionUuid,
                        'refund',
                      ]),
                  )
                );
              }}>
              {({ getFieldValue }: any) => {
                const balanceLimit = (otherPay || []).reduce((p, c) => {
                  // 用户输入的值
                  const _userInputNum = toNumber(
                    getFieldValue([
                      'transactions',
                      c.type,
                      c.chargedTransactionUuid,
                      'refund',
                    ]),
                  );
                  const userInputNum = Number.isNaN(_userInputNum)
                    ? 0
                    : _userInputNum;

                  const actualValue =
                    userInputNum >= c.available
                      ? c.available
                      : userInputNum > 0
                      ? userInputNum
                      : 0;
                  const add1 = accAdd(p, c.available);
                  const res = accSub(add1, actualValue);
                  return res;
                }, 0);
                return (
                  getFieldValue('newStoreCredit') && (
                    <Fragment>
                      <Form.Item
                        name={['storeCredit', 'balance']}
                        label={getI18n(
                          'allOrders.orderDetail.refund_components_returndetail_balancereturn_label',
                        )}
                        initialValue={0}
                        rules={[
                          {
                            required: true,
                            message: getI18n(
                              'allOrders.orderDetail.refund_components_returndetail_balancereturn_rules_msg',
                            ),
                          },
                          {
                            async validator(_, value) {
                              if (Number(value) > balanceLimit) {
                                return Promise.reject(
                                  new Error(
                                    getI18n(
                                      'allOrders.orderDetail.refund_components_returndetail_balancereturn_rules_error',
                                    ),
                                  ),
                                );
                              }
                              return Promise.resolve();
                            },
                          },
                        ]}
                        extra={`${replaceI18nVariables(
                          getI18n(
                            'allOrders.orderDetail.refund_components_returndetail_balancereturn_rules_extra',
                          ),
                          balanceLimit,
                        )}`}
                        labelCol={{ span: 24 }}>
                        <NumberInput
                          size='large'
                          disabled={disabled}
                          mode={EnumMode.money}
                          suffix={currencyCode}
                          decimalPosition={decimalPosition} //decimalPosition={decimalPosition}
                        />
                      </Form.Item>
                      <Form.Item
                        name={['storeCredit', 'expirationDate']}
                        label={getI18n(
                          'allOrders.orderDetail.refund_components_returndetail_expirationreturn_label',
                        )}
                        rules={[
                          {
                            async validator(_, value) {
                              if (
                                Number(value.period) <= 0 ||
                                !(value.unit || '').trim()
                              ) {
                                return Promise.reject(
                                  new Error(
                                    getI18n(
                                      'allOrders.orderDetail.refund_components_returndetail_expirationreturn_rules_error',
                                    ),
                                  ),
                                );
                              }
                              return Promise.resolve();
                            },
                          },
                        ]}
                        labelCol={{ span: 24 }}>
                        <RenderInputWidthSelect disabled={disabled} />
                      </Form.Item>
                      {orderBuyerEmail && !disabled ? (
                        <Form.Item
                          //  name={['storeCredit', 'buyerEmail']}
                          label={`${getI18n(
                            'allOrders.orderDetail.components_refunddetail_buyeremailreturn_label',
                          )} ${orderBuyerEmail && !disabled ? '' : '*'}`}
                          // rules={[
                          //   {
                          //     required: true,
                          //     message: 'Buyer’s Email Is Required',
                          //   },
                          // ]}
                          labelCol={{ span: 24 }}>
                          {/* <Input disabled={disabled} size='large' /> */}
                          <div> {orderBuyerEmail}</div>
                        </Form.Item>
                      ) : (
                        <Form.Item
                          name={['storeCredit', 'buyerEmail']}
                          label={`${getI18n(
                            'allOrders.orderDetail.components_refunddetail_buyeremailreturn_label',
                          )} ${orderBuyerEmail && !disabled ? '' : '*'}`}
                          rules={[
                            {
                              required: true,
                              message: replaceI18nVariables(
                                getI18n('general.fieldisrequired'),
                                getI18n(
                                  'allOrders.orderDetail.components_refunddetail_buyeremailreturn_label',
                                ),
                              ),
                            },
                          ]}
                          labelCol={{ span: 24 }}>
                          {/* <Input disabled={disabled} size='large' /> */}
                          <Input disabled={disabled} size='large' />
                        </Form.Item>
                      )}
                      {/* <Form.Item
                        name={['storeCredit', 'buyerEmail']}
                        label={`${getI18n(
                          'allOrders.orderDetail.refund_components_returndetail_buyeremailreturn_label',
                        )} ${orderBuyerEmail && !disabled ? '' : '*'}`}
                        rules={[
                          {
                            required: true,
                            message: getI18n(
                              'allOrders.orderDetail.refund_components_returndetail_buyeremailreturn_rules_msg',
                            ),
                          },
                        ]}
                        labelCol={{ span: 24 }}>
                   
                        {orderBuyerEmail && !disabled ? (
                          <div> {orderBuyerEmail}</div>
                        ) : (
                          <Input disabled={disabled} size='large' />
                        )}
                      </Form.Item> */}

                      {/* <Form.Item
                        name={['storeCredit', 'buyerEmail']}
                        label={`Buyer’s Email ${
                          orderBuyerEmail && !disabled ? '' : '*'
                        }`}
                        rules={[
                          {
                            required: true,
                            message: 'Buyer’s Email Is Required',
                          },
                        ]}
                        labelCol={{ span: 24 }}>
                        {orderBuyerEmail && !disabled ? (
                          <div> {orderBuyerEmail}</div>
                        ) : (
                          <Input disabled={disabled} size='large' />
                        )}
                      </Form.Item> */}
                      {getAreaCodeUuid(buyerAreaCodeInfo) &&
                      buyerMobile &&
                      !disabled ? (
                        <div>
                          + {getAreaCode(buyerAreaCodeInfo)} {buyerMobile}
                        </div>
                      ) : (
                        <Form.Item
                          name={['storeCredit', 'buyerPhoneNo']}
                          label={`${getI18n(
                            'allOrders.orderDetail.refund_components_returndetail_buyerphonereturn_label',
                          )}${
                            getAreaCodeUuid(buyerAreaCodeInfo) &&
                            buyerMobile &&
                            !disabled
                              ? ''
                              : '*'
                          }`}
                          rules={[
                            {
                              async validator(_, value) {
                                if (
                                  !(
                                    getAreaCodeUuid(value.areaCodeInfo) || ''
                                  ).trim() ||
                                  !(value.mobile || '').trim()
                                ) {
                                  return Promise.reject(
                                    new Error(
                                      getI18n(
                                        'allOrders.orderDetail.refund_components_returndetail_buyerphonereturn_rules_error',
                                      ),
                                    ),
                                  );
                                }
                                return Promise.resolve();
                              },
                            },
                          ]}
                          labelCol={{ span: 24 }}>
                          {getAreaCodeUuid(buyerAreaCodeInfo) &&
                          buyerMobile &&
                          !disabled ? (
                            <div>
                              + {getAreaCode(buyerAreaCodeInfo)} {buyerMobile}
                            </div>
                          ) : (
                            <RenderSelectWidthInput
                              areaCodes={areaCodes}
                              disabled={disabled}
                            />
                          )}
                        </Form.Item>
                      )}
                    </Fragment>
                  )
                );
              }}
            </Form.Item>
          </div>
        </div>
      </Form>
      <ModalFooter
        frontCountTip={replaceI18nVariables(
          getI18n(
            'allOrders.orderDetail.refund_components_returndetail_modalfooter',
          ),
          disabled ? dataItem.length : selectedRowKeys.length,
        )}
        {...(!disabled ? { onOk: () => form.submit() } : {})}
        // hideOkButton={
        //   !selectedRowKeys.length && !customisationCheckedItems.length
        // }
        onCancel={onModalCancel}
        okText={getI18n(
          'allOrders.orderDetail.refund_components_returndetail_oktext',
        )}
      />
    </Fragment>
  );
};

export default RefundDetail;
